// components/Ifta/IftaReport.jsx
import React from "react";
import { ChevronDown, ChevronUp, Info, Calculator } from "lucide-react";
import IftaSummaryCards from "./IftaSummaryCards";
import IftaHeader from "./IftaHeader";

export default function IftaReport({
  calculation,
  showExplanation,
  setShowExplanation,
  formatNum,
  formatMoney,
  iftaDetails,
  params,
  vehicle,
  getQuarterDateRange,
}) {
  if (!calculation) return null;

  return (
    <div id="report-content">
      <IftaHeader
        iftaDetails={iftaDetails}
        params={params}
        getQuarterDateRange={getQuarterDateRange}
        vehicle={vehicle}
      />
      <p className="text-muted small pt-2 text-center">
        This Calculator aims to provide estimations based on standard IFTA-101
        logic. Rates used are illustrative 2025 Q4 samples. Official returns
        should verify rates with IFTA Inc.
      </p>
      <div className="custom_padding">
        <IftaSummaryCards calculation={calculation} />
        <div>
          {calculation?.summary?.mpg === 0 ? (
            <div className="p-5 text-center">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning mb-3"
                style={{ width: 64, height: 64 }}
              >
                <Info size={32} />
              </div>
              <h5>Insufficient Data</h5>
              <p className="text-muted">
                We cannot calculate MPG because total fuel purchased is zero.
              </p>
            </div>
          ) : (
          
              <div
              
              >
                <table className="table table-sm table-bordered align-middle mb-0 custom_table_report">
                  <thead className="table-light small ">
                    <tr>
                      <th></th>
                      <th>Jurisdiction</th>
                      <th className="text-end">Tax Rate</th>
                      <th className="text-end">Miles</th>
                      <th className="text-end bg-primary-subtle">
                        Taxable Gal
                      </th>
                      <th className="text-end">Paid Gal</th>
                      <th className="text-end">Net Gal</th>
                      <th className="text-end">Tax</th>
                      <th className="text-end">Surcharge</th>
                      <th className="text-end text-success fw-bold">
                        Overpaid
                      </th>
                      <th className="text-end fw-bold">Balance Due</th>
                    </tr>
                  </thead>

                  <tbody   >
                   { calculation?.details?.map((row, index) => (
                    <tr  key={row?.jurisdiction}
                className={`index % 4 === 0 ?  "page-break" : "" table-primary`} >
                      <td className="text-center">
                        <ChevronUp size={14} className="text-secondary" />
                      </td>
                      <td>
                        <strong>{row?.jurisdiction}</strong>
                      </td>
                      <td className="text-end">
                        {parseFloat(row?.taxRate)?.toFixed(4)}
                      </td>
                      <td className="text-end">{formatNum(row?.totalMiles)}</td>
                      <td className="text-end bg-primary-subtle fw-semibold">
                        {formatNum(row?.taxableGallons)}
                      </td>
                      <td className="text-end">
                        {formatNum(row?.taxPaidGallons)}
                      </td>
                      <td className="text-end">
                        {formatNum(row?.netTaxableGallons)}
                      </td>
                      <td className="text-end">{formatMoney(row?.taxDue)}</td>
                      <td className="text-end text-muted">
                        {row?.surchargeDue > 0
                          ? formatMoney(row?.surchargeDue)
                          : "-"}
                      </td>
                      <td className="text-end text-success">
                        {row?.totalDue < 0
                          ? formatMoney(Math.abs(row?.totalDue))
                          : "-"}
                      </td>
                      <td
                        className={`text-end fw-bold ${row?.totalDue > 0 ? "text-warning" : "text-muted"}`}
                      >
                        {row?.totalDue > 0 ? formatMoney(row?.totalDue) : "-"}
                      </td>
                    </tr>
                      ))}
                  </tbody>
                     
                </table>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
